const NOTIFICATION_ACTIONS = {
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  POP_NOTIFICATION: 'POP_NOTIFICATION',
  REMOVE_ALL_NOTIFICATION: 'REMOVE_ALL_NOTIFICATION',
};
export default NOTIFICATION_ACTIONS;
